import type {
  GoalsModel,
  QuizAnswersStorageModel,
  QuizCollectionModel,
  QuizConfigModel,
  QuizOptionsModel,
} from '@/common/models/quiz.model';

export function useQuiz() {
  const {
    $quiz,
    $db,
  } = useNuxtApp();
  const router = useRouter();
  const route = useRoute();
  const selectedAnswer = ref<number | QuizOptionsModel>();
  const { main_goal, secondary_goal } = route.query;
  const goals = ref({ main: main_goal as string, additional: secondary_goal as string });
  const isAddGoal = ref(false);

  function setGoals(newGoals: GoalsModel): void {
    goals.value = newGoals;
    $db?.setItem('goals', newGoals);
  }

  function setAddGoal(choice: boolean): void {
    isAddGoal.value = choice;
    $db?.setItem('addGoal', choice);
  }

  async function getQuizAnswers(): Promise<QuizAnswersStorageModel> {
    return $db?.getItem('quiz') ?? {};
  }

  async function getQuizSteps(): Promise<number> {
    const value = await $db?.getItem('steps');
    return value || 3;
  }

  async function setQuizSteps(value: number): Promise<void> {
    await $db?.setItem('steps', value);
  }

  async function saveAnswerToLocally(answerId: number) {
    await router.replace({ query: { ...route.query, [String(currentQuestionId.value)]: String(answerId) } });
    const localQuiz = await $db?.getItem('quiz') ?? {};
    const savedQuiz = Number(currentQuestionId.value) === 0 ? {} : localQuiz;

    savedQuiz[currentQuestionId.value] = answerId;
    // Записываем ответы в объект, где ключ объекта id вопроса, а value объекта это id ответа
    await $db?.setItem('quiz', savedQuiz);
  }

  const currentQuestionId = computed((): string => {
    return route.params.id as string;
  });

  const currentQuestion = computed((): QuizConfigModel => {
    return quiz.value[route.params.id as string] as QuizConfigModel;
  });

  const nextLink = computed((): string => {
    const link = currentQuestion.value?.nextLink;

    if (Number.isInteger(link)) {
      return `/quiz/${link}/${quiz.value[link as number].type}`;
    }

    return link as string;
  });

  const prevLink = computed((): string => {
    const link = currentQuestion.value.prevLink;

    if (Number.isInteger(link)) {
      return `/quiz/${link}/${quiz.value[Number(link)].type}`;
    }

    return `${link}`;
  });

  const currentProgress = computed((): number => {
    if (nextLink.value === '/quiz/creating-plan') {
      return 100;
    }
    return currentQuestion.value?.progress;
  });

  const quiz = computed((): QuizCollectionModel => {
    // only for vitest snapshot tests
    // if (nodeProcess.env.NODE_ENV === 'test') {
    //   return route.query.ver === '2' ? quizV2 : quizBaseline;
    // }

    return $quiz?.value.quiz as QuizCollectionModel;
  });

  (async () => {
    isAddGoal.value = await $db?.getItem('addGoal');
  })();

  return {
    currentQuestionId,
    currentQuestion,
    selectedAnswer,
    nextLink,
    prevLink,
    currentProgress,
    setGoals,
    goals,
    setAddGoal,
    isAddGoal,
    saveAnswerToLocally,
    getQuizAnswers,
    getQuizSteps,
    setQuizSteps,
    quiz,
  };
}
